import { NgModule, Optional, SkipSelf } from "@angular/core";

import { MenuService } from "./menu/menu.service";
import { throwIfAlreadyLoaded } from "./module-import-guard";
import { NotificationsService } from "./notifications/notifications.service";
import { AuthenticationService } from "./services/authentication.service";
import { SettingsService } from "./settings/settings.service";
import { ThemesService } from "./themes/themes.service";

@NgModule({
  imports: [],
  providers: [
    SettingsService,
    MenuService,
    ThemesService,
    NotificationsService,
    AuthenticationService,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, "CoreModule");
  }
}
